import ff from './ff';

export default class c40d { // 機能情報

static d_defs = {

/*
  DROP TABLE t_c40r;
  CREATE TABLE t_c40r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c40rc11s TEXT,
    c40rc31s TEXT,
    c40ri11s TEXT,
    c40rt11i TEXT,
    c40rcx1i INTEGER,
    c40rcy1t TEXT,
    c40rcy1f INTEGER,
    c40rcz1i INTEGER
  );
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1010', '優先エントリー', 'i1zv1c', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1020', '優先エントリー抽選', 'i1yv1b', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1030', 'エントリー', 'i1zv1b', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1040', 'エントリー抽選', 'i1yv1a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1050', '直接予約', 'i1zv1a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1060', '使用状況', 'i1zv3a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1070', '実績集計表', 'i1zv6a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('1080', '支払状況', 'i1zv8a', 10, 9999, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2010', '団体種別', 'i15v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2020', '団体活動カテゴリ', 'i16v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2030', '団体登録', 'c30v1a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2040', '休館日', 'c60v1a', 10, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2050', '時間帯区分', 'i11v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('2060', '室・設備', 'i10v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('3010', 'スタッフ登録', 'c10v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('3020', '権限分類', 'c41v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('3030', 'スタッフ権限割当', 'c42v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c40r (c40rc11s, c40rc31s, c40ri11s, c40rt11i, c40rcx1i, c40rcy1t, c40rcy1f, c40rcz1i)
  VALUES ('4010', '文章変更・その他設定', 'c51v1a', 20, 9999, '2000-01-01 00:00:00', 1, 10);

*/

  c40r: {
    0: {
      pfx: 'モジュール情報',
      b_vsn: false,
      d_insFlds: {
        c40rc11s: '',
        c40rc31s: '',
        c40ri11s: '',
      },
      dd_fldDefss: { // 利用会社ごとに分ない
        c40rc11s: {
          pfx: 'ID',
          type: 'Inp',
          n_col: 5,
        },
        c40rc31s: {
          pfx: '表記',
          type: 'Inp',
          n_col: 10,
        },
        c40ri11s: {
          pfx: 'モジュールCD',
          type: 'Inp',
          n_col: 10,
        },
        c40rt11i: {
          pfx: '種別',
          type: 'Pck',
          n_col: 10,
          ld_iss: [
            { key: 10, pfx: '主' },
            { key: 20, pfx: '副' }
          ],
        },
      },
    },
  },
};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
